import React, { useEffect, useState, useRef, useMemo } from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';
import $, { error } from 'jquery';
import '../Pages/Css/trafico.css'
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import { FaRoute } from "@react-icons/all-files/fa/FaRoute";
import { FaLock } from "@react-icons/all-files/fa/FaLock";
import { motion } from 'framer-motion';
import axios from "../utils/axiosConfig";
import { registerOpenStreetMap } from "../utils/openStreetMapType";
import { set } from "date-fns";
import FormReporteServicio from "../components/formsSolicitudes/formReporteServicio";
import FormReporteServcioModalTracking from "../components/formsSolicitudes/formReporteServcioModalTracking";
import EnviarReporteContratoButton from "../components/EnviarReporteContratoButton";
import { FaInfoCircle } from "@react-icons/all-files/fa/FaInfoCircle";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import { FaFileExcel } from "@react-icons/all-files/fa/FaFileExcel";
import ModalBaseSm from "../components/modals/modal-base-sm";
import ModalInfromacionExtra from "../components/modals/modalInfromacionExtra";
import ModalBaseLg from "../components/modals/modal-base-lg";
import BaseModalAuto2 from "../components/modals/BaseModalAuto2";
import Swal from "sweetalert2";
import { Spinner } from "reactstrap";
import ExcelJS from "exceljs";
import {
  compartirArchivoPorWhatsAppWeb,
  construirPayloadSeguimiento,
  prepararModalSeguimientoWhatsApp,
} from "../utils/whatsappSeguimiento";
var miStorage = window.localStorage;
const PUBLIC_ASSET_BASE_URL = "https://cargotronics.com";
let reporteContratoInstanceCounter = 0;

const getShareErrorText = (error) => {
  const stageMap = {
    "capture-element": "No se encontro el contenedor visual del modal para capturarlo.",
    "capture-blob": "La captura se genero, pero no se pudo convertir en imagen PNG.",
    "share-not-ready": "Primero debes preparar la captura antes de compartirla.",
    "share-not-supported": "Tu navegador o dispositivo no permite compartir imagenes directamente desde la web.",
    "share-native-gesture": "Tu navegador exige que la accion de compartir se dispare como un gesto directo del usuario y puede pedir repetir el intento.",
    "share-native": "El panel nativo de compartir no pudo completarse correctamente.",
    "share-whatsapp-web": "No pudimos abrir WhatsApp Web automaticamente para completar el envio.",
    "share-unknown": "Ocurrio un error inesperado durante el proceso de compartido.",
  };

  const stageLabel = stageMap[error?.stage] || "No se pudo completar el flujo de compartido.";
  const detail = error?.message ? `Detalle: ${error.message}` : "";

  return [stageLabel, detail].filter(Boolean).join("\n");
};

const Modal = ({
  isOpen,
  onClose,
  contratoVar,
  aleatorio,
  children,
  images,
  monitoreo,
  isLoading,
  consolidado,
  videos,
  streaming,
  valitronics,
  checkList,
  trayecto,
  showEditContract,
  rutaseleccionadaprop,
  bitInsertMonitoreo: bitInsertMonitoreoProp = false,
  bitEditMonitoreo: bitEditMonitoreoProp = false,
  isMultiventana = false,
}) => {
  let directionsService;
  const google = window.google;
  const [listaMensajes, setListaMensajes] = useState([]);
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [uniquesGeocerca, setUniquesGeocerca] = useState([]);
  const [infoWindows, setInfoWindows] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [contratoseleccionado, setContratoseleccionado] = useState(null);
  const [markers, setMarkers] = useState([]);
  const circleRef = useRef(null);
  const markersRef = useRef([]);
  const polylineRef = useRef([]);
  const infoWindowRef = useRef(null);
  const mapRef = useRef(null);
  const intervalRef = useRef(null);
  const [switchValue, setSwitchValue] = useState(false);
  const [switchValueGeo, setSwitchValueGeo] = useState(false);
  const [autocentradoValue, setAutocentradoValue] = useState(false);
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState(null);
  const [activeTab, setActiveTab] = useState("tabla");
  const [bitOpenMonitoreo, setBitOpenMonitoreo] = useState(false);
  const [bitInsertMonitoreo, setBitInsertMonitoreo] = useState(bitInsertMonitoreoProp);
  const [bitEditMonitoreo, setBitEditMonitoreo] = useState(bitEditMonitoreoProp);
  const [lastReport, setLastReport] = useState(null);
  const [modalInformacionExtra, setModalInformacionExtra] = useState(false);
  const [showIconModal, setShowIconModal] = useState(false);
  const [activeIconFilter, setActiveIconFilter] = useState(null);
  const [geocercaPolygons, setGeocercaPolygons] = useState([]);
  const [preparandoWhatsapp, setPreparandoWhatsapp] = useState(false);
  const [trackingMetrics, setTrackingMetrics] = useState({
    distanciaRuta: "N/A",
    distanciaFaltante: "N/A",
  });
  const [shareProgress, setShareProgress] = useState({
    progress: 0,
    message: "Preparando...",
  });
  const [loadingSeguimiento, setLoadingSeguimiento] = useState(false);
  const [exportandoExcel, setExportandoExcel] = useState(false);
  const [sharePrepared, setSharePrepared] = useState(null);
  const pendingSharePreparationRef = useRef(null);
  const sharePreparationTimerRef = useRef(null);
  const sharePreparationVersionRef = useRef(0);
  const mapIdleListenerRef = useRef(null);
  const mapInteractionListenersRef = useRef([]);
  const isMountedRef = useRef(false);
  const rootRef = useRef(null);
  const mapContainerRef = useRef(null);
  const instanceKeyRef = useRef(null);

  if (!instanceKeyRef.current) {
    reporteContratoInstanceCounter += 1;
    instanceKeyRef.current = `seguimiento-${reporteContratoInstanceCounter}`;
  }

  const instanceKey = instanceKeyRef.current;
  const scopedId = (id) => `${id}-${instanceKey}`;
  const getScopedElement = (id) => rootRef.current?.querySelector(`#${scopedId(id)}`);

  const safeSetHtml = (id, html) => {
    const el = getScopedElement(id);
    if (el) {
      el.innerHTML = html;
    }
  };


  const isIntervalActive = () => {
    return intervalRef.current !== null;
  };

  const clearSharePreparationTimer = () => {
    if (sharePreparationTimerRef.current) {
      clearTimeout(sharePreparationTimerRef.current);
      sharePreparationTimerRef.current = null;
    }
  };

  const clearMapShareListeners = () => {
    if (mapIdleListenerRef.current) {
      google.maps.event.removeListener(mapIdleListenerRef.current);
      mapIdleListenerRef.current = null;
    }

    if (mapInteractionListenersRef.current.length) {
      mapInteractionListenersRef.current.forEach((listener) => {
        google.maps.event.removeListener(listener);
      });
      mapInteractionListenersRef.current = [];
    }
  };

  useEffect(() => {
    isMountedRef.current = isOpen;
    if (isOpen) {
      setActiveTab("tabla");
      setBitOpenMonitoreo(false);
      setBitInsertMonitoreo(false);
      setBitEditMonitoreo(false);
      setSwitchValue(false);
      setSwitchValueGeo(false);
      setTrackingMetrics({
        distanciaRuta: "N/A",
        distanciaFaltante: "N/A",
      });
      setPreparandoWhatsapp(false);
      setSharePrepared(null);
      pendingSharePreparationRef.current = null;
      clearSharePreparationTimer();
      setShareProgress({
        progress: 0,
        message: "Preparando...",
      });
      console.log("Contrato reporte abierto: ", contratoVar);
      $(rootRef.current).find(`#${scopedId("success-alert")}`).hide();
      $(rootRef.current).find(`#${scopedId("danger-alert")}`).hide();
      setListaMensajes([]);
      setInfoWindows([]);
      setSelectedMarkerIndex(null);
      setMarkers([]);
      setLoadingSeguimiento(true);
      RenderMap();
      setContratoseleccionado(contratoVar);
      ListReports(contratoVar, 0, 1);
      safeSetHtml("dispositivo_seg", contratoVar.FKLokDeviceID);
      safeSetHtml("contrato_seg", contratoVar.ContractID);
      safeSetHtml("cliente_seg", contratoVar.NombreEmpresa);
      safeSetHtml("ruta_seg", contratoVar.DescripcionRuta);

      if (contratoVar.trayecto !== 0) {
        GetPolyline();
      }

      // Solo activa el seguimiento si el switch está activado
      if (switchValue && !isMultiventana) {
        handleVerSeguimientoClick();
      }
    } else {
      clearInterval(intervalRef.current); // Limpia el intervalo al cerrar el modal
      intervalRef.current = null;
      setLoadingSeguimiento(false);
    }

    return () => {
      // Limpieza al desmontar el componente
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      isMountedRef.current = false;
      clearSharePreparationTimer();
      clearMapShareListeners();
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return undefined;

    let cancelled = false;

    const cargarPermisoMonitoreo = async () => {
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_SERVER}/usuarios/getconfiguracionpagina`,
          JSON.stringify({ pagina: "14" }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("tkn")}`,
            },
            withCredentials: true,
          }
        );

        const permitido = Boolean(res.data?.data?.[0]?.bitOpen);
        const permiteInsertar = Boolean(res.data?.data?.[0]?.bitInsert);
        const permiteEditar = Boolean(res.data?.data?.[0]?.bitEdit);
        if (cancelled) return;

        setBitOpenMonitoreo(permitido);
        setBitInsertMonitoreo(permiteInsertar);
        setBitEditMonitoreo(permiteEditar);
        if (!permitido) {
          setActiveTab("tabla");
        }
      } catch (error) {
        if (cancelled) return;
        console.error("Error al consultar permiso de monitoreo:", error);
        setBitOpenMonitoreo(false);
        setBitInsertMonitoreo(false);
        setBitEditMonitoreo(false);
        setActiveTab("tabla");
      }
    };

    cargarPermisoMonitoreo();

    return () => {
      cancelled = true;
    };
  }, [isOpen]);

  useEffect(() => {
    if (switchValue && !isMultiventana) {
      handleVerSeguimientoClick();
    }
  }, [switchValue, isMultiventana]);

  useEffect(() => {
    if (!isMultiventana) return undefined;

    setSwitchValue(false);
    clearInterval(intervalRef.current);
    intervalRef.current = null;

    return undefined;
  }, [isMultiventana]);

  useEffect(() => {
    if (isOpen && contratoVar.trayecto !== 0) {
      GetPolyline()
    }
  }, [isOpen, contratoVar.trayecto])

  const RenderMap = () => {
    const coords = { lat: 10.992716649650994, lng: -74.80259436365039 };
    try {
      const el = mapContainerRef.current;
      if (el && google?.maps) {
        clearMapShareListeners();
        mapRef.current = new google.maps.Map(el, {
          zoom: 16,
          center: coords,
        });
        registerOpenStreetMap(google, mapRef.current);

        const markMapAsDirty = () => {
          if (!isMountedRef.current) return;
          invalidatePreparedShare();
        };
        mapInteractionListenersRef.current = [
          google.maps.event.addListener(mapRef.current, "dragstart", markMapAsDirty),
          google.maps.event.addListener(mapRef.current, "zoom_changed", markMapAsDirty),
        ];
        return mapRef.current;
      } else {
        return null;
      }
    } catch (error) {
      window.history.go(0);
    }
  };

  const GetPolyline = () => {
    // console.log("Dibujando trayecto en el mapa:", contratoVar.trayecto);
    // console.log("Dibujando trayecto en el mapa:", rutaseleccionadaprop);
    try {
      let data = {};
      if (rutaseleccionadaprop !== -1) {
        data = { "id": rutaseleccionadaprop };
      } else {
        data = { "id": contratoVar.trayecto };
      }
      // console.log("data", data);
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/getpolylinetrayecto', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success) {
            // console.log("Ruta completa:", response.data.data[0].Polyline);
            let rutacompleta = response.data.data[0].Polyline.split("||||");
            rutacompleta.forEach((ruta) => {
              const decodedPath = google.maps.geometry.encoding.decodePath(ruta);
              const polyline = new google.maps.Polyline({
                path: decodedPath,
                geodesic: true,
                strokeColor: "#ffae00ff",
                strokeOpacity: 0.7,
                strokeWeight: 6,
              });
              polyline.setMap(mapRef.current);
            });
          }
        }).catch(console.error);
    } catch (error) {
      console.error(error);
    }
  };

  // const GetPolylineRoute = (ruta) => {
  //   console.log("Dibujando trayecto en el mapa:", ruta);

  //   try {
  //     let data = { "id": ruta };
  //     const json = JSON.stringify(data);
  //     axios.post(process.env.REACT_APP_SERVER + '/operaciones/getpolylinetrayecto', json, {
  //       headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
  //       withCredentials: true
  //     })
  //       .then(response => {
  //         if (response.data.success) {
  //           let rutacompleta = response.data.data[0].Polyline.split("||||");
  //           rutacompleta.forEach((ruta) => {
  //             const decodedPath = google.maps.geometry.encoding.decodePath(ruta);
  //             const polyline = new google.maps.Polyline({
  //               path: decodedPath,
  //               geodesic: true,
  //               strokeColor: "#FF0000",
  //               strokeOpacity: 0.4,
  //               strokeWeight: 6,
  //             });
  //             polyline.setMap(mapRef.current);
  //           });
  //         }
  //       }).catch(console.error);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const ListReports = (contrato, all, op) => {
    // console.log("all", all);
    // console.log("op", op);
    const imagen = contrato.Locked === 0 ? 'Apertura' : 'Cierre';
    const estadoCard = getScopedElement("contenedorestadodiv");
    const estadoText = getScopedElement("contenedorestado");
    if (estadoCard) {
      estadoCard.style.background = contrato.Locked === 0 ? '#D21F1F' : '#058315';
    }
    if (estadoText) {
      estadoText.innerHTML = imagen;
    }
    setLoadingSeguimiento(true);

    try {
      let data = {
        "fechainicio": contrato.fechainicio || contrato.fecha,
        "fechafin": contrato.fechafin,
        "device": contrato.FKLokDeviceID,
        "utcMinutos": 5,
        "allreport": all,
        "tipo": contrato.Active,
        "tipoequipo": contrato.FKLokTipoEquipo,
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/getreportesdevice', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success) {
            Swal.close();
            if (!isMountedRef.current) return;
            const prevMarkersList = markersRef.current;
            const reportes = Array.isArray(response.data.data) ? response.data.data : [];
            console.log('Reportes obtenidos(counttrafico):', reportes.length);
            if (reportes.length > 0) {
              safeSetHtml("contenedortiempo", getDateDifferenceText(formatFecha(reportes[0].PositionTime)));
            } else {
              safeSetHtml("contenedortiempo", "Sin datos");
            }
            if (contrato.trayecto !== 0 && reportes.length > 0) {
              cumplimientoRuta(contrato, reportes[0]);
            }
            if (op === 1) {
              setMarkers(prevMarkersList);
            } else {
              setMarkers([]);
            }
            console.log("Reportes filtrados para mapa:", reportes);
            setListaFiltrada(reportes);
            setListaMensajes(reportes);
            rutaenMapa(reportes, op);
          }
        }).catch((error) => {
          setLoadingSeguimiento(false);
          Swal.close();
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener los reportes',
            text: 'Ocurrió un error al obtener las posiciones, por favor intente nuevamente.',
          });
          console.error(error);
        });
    } catch (error) {
      setLoadingSeguimiento(false);
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error al obtener los reportes',
        text: 'Ocurrió un error al obtener las posiciones, por favor intente nuevamente.',
      });
      console.error(error);
    }
  };

  function cumplimientoRuta(contrato, mensaje) {
    directionsService = new google.maps.DirectionsService();
    calcAddress(directionsService, contrato, mensaje);
  }

  function calcAddress(directionsService, contrato, mensaje) {

    directionsService.route(
      {
        origin: {
          query: contrato.Origen,
        },
        destination: {
          query: mensaje.latitude + "," + mensaje.longitude,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      },
      (response, status) => {

        if (status === 'OK') {
          if (!isMountedRef.current) return;
          const ruta = response.routes[0].legs;
          var distancia = 0;
          for (var i = 0; i < ruta.length; i++) {
            distancia += ruta[i].distance.value;
          }
          safeSetHtml(
            "informacioneventos",
            "<b>Distancia ruta:</b> " +
            (contrato.DistanciaCompleta / 1000).toFixed() +
            "Km - " +
            "<b>Distancia faltante:</b> " +
            ((contrato.DistanciaCompleta - distancia) / 1000).toFixed() +
            "Km"
          );
          setTrackingMetrics({
            distanciaRuta: `${(contrato.DistanciaCompleta / 1000).toFixed()} Km`,
            distanciaFaltante: `${((contrato.DistanciaCompleta - distancia) / 1000).toFixed()} Km`,
          });
          var distanciaporcentaje = (distancia / contrato.DistanciaCompleta) * 100;
          safeSetHtml("contenedordistancia", distanciaporcentaje.toFixed() + "%");
        } else {
        }
      }
    );
  }

  const uniqueIconPaths = useMemo(() => {
    console.log("► listaMensajes:", listaMensajes);
    if (!listaMensajes.length) return [];
    const icons = listaMensajes.flatMap(msg =>
      Object.entries(msg)
        .filter(([k, v]) => k.startsWith("Icon") && v && !v.includes("transparent") && v.includes(".png") && v.includes("images/"))
        .map(([_, url]) => url.substring(1))   // quito el "~"
    );
    const unique = Array.from(new Set(icons));
    console.log("► uniqueIconPaths:", unique);
    return unique;  // ej: ["/images/stop.png", "/images/openedpadlock.png", …]
  }, [listaMensajes]);



  // 3) Funciones para filtrar/limpiar marcadores
  const filterMarkersByIcon = iconPath => {
    setActiveIconFilter(iconPath);
    const nuevaLista = listaMensajes.filter(msg =>
      // comprueba todos los campos Icon* para ese msg
      Object.entries(msg)
        .filter(([k]) => k.startsWith("Icon"))
        .some(([_, url]) => url && url.includes(iconPath))
    );
    setListaFiltrada(nuevaLista);
    setShowIconModal(false);
  };


  const clearIconFilter = () => {
    setActiveIconFilter(null);
    setListaFiltrada(listaMensajes);
    setShowIconModal(false);
  };

  const getIconOptionLabel = (iconPath) => {
    const fileName = String(iconPath || "").split("/").pop() || "";
    const normalized = fileName.replace(/\.(png|gif|jpg|jpeg)$/i, "");
    if (!normalized) return "Icono";

    return normalized
      .replace(/[-_]+/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const buildSeguimientoPayload = () =>
    construirPayloadSeguimiento(
      contratoVar,
      lastReport,
      trackingMetrics
    );

  const invalidatePreparedShare = (message = "Preparando...") => {
    sharePreparationVersionRef.current += 1;
    setSharePrepared(null);
    setShareProgress({
      progress: 0,
      message,
    });
  };

  const resetPreparedShare = (message = "Preparando...") => {
    invalidatePreparedShare(message);
  };

  const prepareShareCapture = (
    customMessage = "Preparando captura para compartir...",
    requestedVersion = sharePreparationVersionRef.current
  ) => {
    if (
      pendingSharePreparationRef.current &&
      pendingSharePreparationRef.current.version === requestedVersion
    ) {
      return pendingSharePreparationRef.current.promise;
    }

    setPreparandoWhatsapp(true);
    setSharePrepared(null);
    setShareProgress({
      progress: 8,
      message: customMessage,
    });

    const seguimiento = buildSeguimientoPayload();
    const promise = prepararModalSeguimientoWhatsApp(seguimiento, {
      elementId: scopedId("modal-seguimiento-whatsapp-captura"),
      onProgress: ({ progress, message }) => {
        if (!isMountedRef.current || requestedVersion !== sharePreparationVersionRef.current) return;
        setShareProgress({
          progress,
          message,
        });
      },
    })
      .then((result) => {
        if (!isMountedRef.current) return result;
        if (requestedVersion !== sharePreparationVersionRef.current) {
          return result;
        }
        setSharePrepared(result);
        setShareProgress({
          progress: 100,
          message: "Imagen lista. El boton abrira WhatsApp Web e intentara copiar el texto y la imagen al portapapeles.",
        });
        return result;
      })
      .catch((error) => {
        if (isMountedRef.current && requestedVersion === sharePreparationVersionRef.current) {
          setShareProgress({
            progress: 0,
            message: "No se pudo preparar la imagen para compartir.",
          });
        }
        throw error;
      })
      .finally(() => {
        if (pendingSharePreparationRef.current?.version === requestedVersion) {
          pendingSharePreparationRef.current = null;
        }
        if (isMountedRef.current && requestedVersion === sharePreparationVersionRef.current) {
          setPreparandoWhatsapp(false);
        }
      });

    pendingSharePreparationRef.current = {
      version: requestedVersion,
      promise,
    };
    return promise;
  };

  const handleCompartirWhatsApp = async () => {
    if (preparandoWhatsapp) return;

    try {
      // Obliga a generar una captura nueva
      invalidatePreparedShare(
        "Preparando imagen para WhatsApp..."
      );

      const prepared = await prepareShareCapture(
        "Preparando imagen para WhatsApp..."
      );

      const result = await compartirArchivoPorWhatsAppWeb(prepared);

      Swal.fire({
        icon: result?.copiedImage ? "success" : "warning",
        title: result?.copiedImage
          ? "Imagen lista"
          : "WhatsApp Web abierto",
        html: result?.copiedImage
          ? `
            <div>
              El texto quedó preparado en WhatsApp Web.<br/><br/>

              La imagen está en el portapapeles.<br/>

              <strong>
                Selecciona el chat y presiona Ctrl + V
              </strong>
            </div>
          `
          : `
            <div>
              WhatsApp Web fue abierto con el texto,
              pero no se pudo copiar la imagen.
            </div>
          `,
        timer: 4000,
        showConfirmButton: false,
      });

    } catch (error) {
      console.error(
        "Error compartiendo seguimiento por WhatsApp:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "No se pudo compartir",
        text: getShareErrorText(error),
      });
    }
  };

  const resolvePublicAssetUrl = (value, fallbackPrefix = "") => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return "";

    if (/^https?:\/\//i.test(rawValue)) {
      return rawValue;
    }

    let normalizedPath = rawValue
      .replace(/^~\//, "/")
      .replace(/^~/, "/")
      .replace(/^\.\//, "/");

    if (!normalizedPath.includes("/") && fallbackPrefix) {
      normalizedPath = `${fallbackPrefix}${normalizedPath}`;
    }

    if (!normalizedPath.startsWith("/")) {
      normalizedPath = `/${normalizedPath}`;
    }

    return `${PUBLIC_ASSET_BASE_URL}${normalizedPath}`;
  };

  const getImageExtensionFromUrl = (url) => {
    const normalizedUrl = String(url || "").toLowerCase();
    if (normalizedUrl.includes(".jpg") || normalizedUrl.includes(".jpeg")) return "jpeg";
    if (normalizedUrl.includes(".gif")) return "gif";
    return "png";
  };

  const imageUrlToBase64 = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`No se pudo descargar la imagen: ${url}`);
    }

    const blob = await response.blob();
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    return typeof base64 === "string" ? base64 : "";
  };

  const getExportCellValue = (value) => {
    if (value === null || value === undefined) return "(vacio)";
    if (typeof value === "string" && value.trim() === "") return "(vacio)";
    return value;
  };

  const handleExportarExcel = async () => {
    const mensajesParaExportar = Array.isArray(listaFiltrada) && listaFiltrada.length > 0
      ? listaFiltrada
      : listaMensajes;

    if (!Array.isArray(mensajesParaExportar) || mensajesParaExportar.length === 0) {
      Swal.fire({
        icon: "info",
        title: "Sin datos para exportar",
        text: "No hay mensajes disponibles para generar el archivo de Excel.",
      });
      return;
    }

    try {
      setExportandoExcel(true);
      const iconColumns = [
        { header: "IconoSatelite", valueKey: "IconSatelite" },
        { header: "IconoMovimiento", valueKey: "IconMoving" },
        { header: "IconoBloqueo", valueKey: "IconLocked" },
        { header: "IconoDesvio", valueKey: "IconDesvio" },
        { header: "IconoRetorno", valueKey: "IconBack" },
        { header: "IconoAlejado", valueKey: "IconAlejado" },
        { header: "IconoMapa", valueKey: "IconMapMarker", fallbackPrefix: "/images/mapcenter_icons/", suffix: ".png" },
      ];

      const headers = [
        "Fecha",
        "Fecha actualizacion",
        "Lugar",
        "Latitud",
        "Longitud",
        "Geocerca",
        "Bateria",
        "GPS",
        "CSQ",
        "Velocidad",
        "Evento",
        ...iconColumns.map((column) => column.header),
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Mensajes");
      worksheet.addRow(headers);

      worksheet.columns = headers.map((header, index) => ({
        header,
        key: header,
        width: index >= 11 ? 22 : (header === "Geocerca" ? 30 : 18),
      }));

      const imageCache = new Map();
      const getImageId = async (url) => {
        if (!url) return null;
        if (imageCache.has(url)) return imageCache.get(url);

        const base64 = await imageUrlToBase64(url);
        const imageId = workbook.addImage({
          base64,
          extension: getImageExtensionFromUrl(url),
        });
        imageCache.set(url, imageId);
        return imageId;
      };

      for (const mensaje of mensajesParaExportar) {
        const rowValues = [
          getExportCellValue(mensaje?.PositionTime ? formatFecha(mensaje.PositionTime) : ""),
          getExportCellValue(mensaje?.DateTimeActualizacion ? formatFecha(mensaje.DateTimeActualizacion) : ""),
          getExportCellValue(mensaje?.latitude === 0 ? "SIN GPS" : (mensaje?.Ciudad || "")),
          getExportCellValue(mensaje?.latitude),
          getExportCellValue(mensaje?.longitude),
          getExportCellValue(mensaje?.NombreGeocerca || ""),
          getExportCellValue(mensaje?.Battery),
          getExportCellValue(mensaje?.SatelliteCount),
          getExportCellValue(mensaje?.csq),
          getExportCellValue(mensaje?.Speed),
          getExportCellValue(mensaje?.Evento),
          ...iconColumns.map(() => null),
        ];

        const addedRow = worksheet.addRow(rowValues);
        addedRow.height = 52;

        for (let columnIndex = 0; columnIndex < iconColumns.length; columnIndex += 1) {
          const column = iconColumns[columnIndex];
          const rawValue = String(mensaje?.[column.valueKey] || "").trim();
          const excelColumn = 12 + columnIndex;
          worksheet.getCell(addedRow.number, excelColumn).value = null;
          if (!rawValue) continue;

          const valueWithSuffix =
            column.suffix && !rawValue.includes("/")
              ? `${rawValue}${column.suffix}`
              : rawValue;

          const assetUrl = resolvePublicAssetUrl(valueWithSuffix, column.fallbackPrefix || "");
          if (!assetUrl) continue;

          try {
            const imageId = await getImageId(assetUrl);
            if (!imageId) continue;

            worksheet.addImage(imageId, {
              tl: { col: excelColumn - 1 + 0.2, row: addedRow.number - 1 + 0.12 },
              ext: { width: 28, height: 28 },
              editAs: "oneCell",
            });
          } catch (iconError) {
            console.warn("No se pudo incrustar el icono en Excel:", assetUrl, iconError);
          }
        }
      }

      const headerRow = worksheet.getRow(1);
      headerRow.font = { bold: true };
      headerRow.height = 22;

      worksheet.views = [{ state: "frozen", ySplit: 1 }];

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob(
        [buffer],
        { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }
      );
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      const contractId = String(contratoVar?.ContractID || "seguimiento").replace(/[^\w-]+/g, "_");
      link.href = url;
      link.download = `seguimiento_${contractId}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exportando mensajes a Excel:", error);
      Swal.fire({
        icon: "error",
        title: "No se pudo exportar",
        text: "Ocurrio un error al generar el archivo de Excel.",
      });
    } finally {
      setExportandoExcel(false);
    }
  };

  const isShareButtonBusy = preparandoWhatsapp;

  const rutaenMapa = (lista, op) => {
    if (!Array.isArray(lista) || lista.length === 0) {
      markersRef.current.forEach(({ marker }) => marker.setMap(null));
      markersRef.current = [];
      setMarkers([]);
      setInfoWindows([]);
      setLoadingSeguimiento(false);
      return;
    }
    // console.log("Lista de mensajes:", lista);
    // console.log("Operación:", op);
    const promises = lista
      .filter((objeto) => objeto.latitude !== 0 && objeto.longitude !== 0)
      .map((objeto) => {
        return new Promise((resolve) => {
          resolve({
            lat: objeto.latitude,
            lng: objeto.longitude,
            id: objeto.ID,
            html: objeto.HTML,
            ubicacion: objeto.Ciudad,
            icon: objeto.IconLocked,
            iconMapMarker: objeto.IconMapMarker
          });
        });
      });

    Promise.all(promises)
      .then((flightPlanCoordinates) => {

        if (op !== 1 && !switchValue) {
          if (polylineRef.current.length > 0) {
            polylineRef.current.forEach((polyline) => polyline.setMap(null));
            polylineRef.current = [];
          }
        }


        // Calcula y muestra las flechas de dirección entre todos los marcadores
        for (let i = 0; i < flightPlanCoordinates.length - 1; i++) {
          const directionArrow = new google.maps.Polyline({
            path: [flightPlanCoordinates[i + 1], flightPlanCoordinates[i]],
            geodesic: true,
            strokeColor: "#88A0CF",
            strokeOpacity: 1.0,
            strokeWeight: 2,
            icons: [
              {
                icon: {
                  path: google.maps.SymbolPath.FORWARD_OPEN_ARROW,
                  scale: 1,
                  strokeColor: "#082357",
                },
                offset: "50%",
              },
            ],
            map: mapRef.current,
          });

          // Agrega esta línea para almacenar la referencia
          polylineRef.current.push(directionArrow);
        }


        const markersList = markersRef.current;

        // Eliminar todos los marcadores anteriores
        markersList.forEach(({ marker }) => marker.setMap(null));
        markersRef.current = [];

        // Crear nuevos marcadores
        const markerslist = flightPlanCoordinates.map((coordinate) => {
          // const iconurl = coordinate.icon.includes("opened")
          //   ? "./truckopen.png"
          //   : "./truckclose.png";
          const markerKey = (coordinate.iconMapMarker && String(coordinate.iconMapMarker).trim())
            ? String(coordinate.iconMapMarker).trim()
            : "default"; // pon aquí el nombre real de tu png default (sin .png)

          const iconurl = `images/mapcenter_icons/${markerKey}.png`;
          const marker = new google.maps.Marker({
            position: coordinate,
            map: mapRef.current,
            id: coordinate.id,
            ubicacion: coordinate.ubicacion,
            icon: {
              url: iconurl,
              scaledSize: new google.maps.Size(30, 30),
            },
          });

          const markerInfoWindow = new google.maps.InfoWindow({
            content: coordinate.html,
          });

          marker.addListener("click", () => {
            if (infoWindowRef.current) {
              infoWindowRef.current.close();
            }
            const mensajeActivo =
              listaMensajes.find((item) => item.ID === coordinate.id) ||
              listaFiltrada.find((item) => item.ID === coordinate.id) ||
              null;
            setSelectedMarkerIndex(coordinate.id);
            setSelectedMarker(marker);
            setSelectedMessage(mensajeActivo);
            markerInfoWindow.open(mapRef.current, marker);
            infoWindowRef.current = markerInfoWindow;
          });

          return { marker, markerInfoWindow };
        });

        markersRef.current = markerslist;

        // Actualizar el círculo en el último marcador
        const updateCircleRadius = () => {
          if (markerslist.length > 0) {
            const lastMarker = markerslist[0].marker;
            const zoomLevel = mapRef.current.getZoom(); // Obtener nivel de zoom actual
            const baseRadius = 3; // Radio base en metros
            const maxZoom = 20; // Zoom máximo
            const scaleFactor = Math.pow(2, maxZoom - zoomLevel); // Escala inversa
            const newRadius = baseRadius * scaleFactor;

            // Eliminar el círculo existente si ya está definido
            if (circleRef.current) {
              circleRef.current.setMap(null);
            }

            // Crear un nuevo círculo
            circleRef.current = new google.maps.Circle({
              strokeColor: 'black',
              strokeOpacity: 1,
              strokeWeight: 2,
              fillColor: '#E0E302',
              fillOpacity: 0.8,
              map: mapRef.current,
              center: lastMarker.getPosition(),
              radius: newRadius,
            });
          }
        };

        // Vincular el evento de zoom al mapa
        google.maps.event.addListener(mapRef.current, 'zoom_changed', updateCircleRadius);

        // Llamar a la función inicialmente para establecer el radio correcto
        updateCircleRadius();

        if (op === 1) {
          const bounds = new google.maps.LatLngBounds();
          markerslist.forEach(({ marker }) =>
            bounds.extend(marker.getPosition())
          );
          invalidatePreparedShare();
          mapRef.current.fitBounds(bounds);
        } else {
          const switchElement = getScopedElement("autocentrado");
          if (switchElement?.checked && markerslist.length > 0) {
            const firstMarker = markerslist[0].marker;
            invalidatePreparedShare();
            mapRef.current.setCenter(firstMarker.getPosition());
          }
        }

        setMarkers(markerslist);
        setInfoWindows(
          markerslist.map(({ markerInfoWindow }) => markerInfoWindow)
        );
        setLoadingSeguimiento(false);
      })
      .catch((error) => {
        setLoadingSeguimiento(false);
        console.error(error);
      });
  };

  const handleMarkerClick = (markerId) => {
    markers.forEach(({ marker, markerInfoWindow }) => {
      markerInfoWindow.close();
      if (marker.id === markerId) {
        const mensajeActivo =
          listaMensajes.find((item) => item.ID === markerId) ||
          listaFiltrada.find((item) => item.ID === markerId) ||
          null;
        markerInfoWindow.open(mapRef.current, marker);
        infoWindowRef.current = markerInfoWindow;
        setSelectedMarkerIndex(markerId);
        setSelectedMarker(marker);
        setSelectedMessage(mensajeActivo);
        invalidatePreparedShare();
        mapRef.current.panTo(marker.getPosition()); // Centrar el mapa en el marcador
        mapRef.current.setZoom(22);
      }
    });

  };


  // Manejadores para abrir/cerrar modal
  const handleMouseEnter = () => {
    setModalInformacionExtra(true);
  };

  const handleMouseLeave = () => {
    setModalInformacionExtra(false);
  };

  const handleTableRowClick = (markerIndex) => {
    // console.log("entro -> " + markerIndex + " total=" + listaMensajes.length);
    const objeto = listaFiltrada[markerIndex];
    if (!objeto) return;
    setSelectedMessage(objeto);
    handleMarkerClick(objeto.ID);
  };

  const handleSwitchChange = (event) => {
    if (isMultiventana) return;

    const newValue = event.target.checked;
    setSwitchValue(newValue);

    if (newValue) {
      if (!isIntervalActive()) {
        handleVerSeguimientoClick();
      }
    } else {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleSwitchChangeGeo = (event) => {
    const newValue = event.target.checked;
    setSwitchValueGeo(newValue);
  };

  const handleVerUltPuntoClick = () => {
    try {
      let obj = listaMensajes[0];
      window.open('https://www.google.com/maps/?q=' + obj.latitude + ',' + obj.longitude + '&z=14', '_blank');
    } catch (error) {
      console.error("Error al abrir el último punto en Google Maps:", error);
    }
  };

  const handleSetUltPunto = () => {
    try {
      if (!selectedMarker?.position || !contratoseleccionado?.ContractID) {
        Swal.fire({
          icon: "warning",
          title: "Punto no valido",
          text: "Selecciona un punto valido antes de setearlo.",
          timer: 2200,
          showConfirmButton: false,
        });
        return;
      }

      let data = {
        "lat": selectedMarker.position.lat(),
        "lng": selectedMarker.position.lng(),
        "id": selectedMarker.id,
        "contrato": contratoseleccionado.ContractID
      };
      const json = JSON.stringify(data);
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/setultimopunto', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success.rowsAffected.length === 1) {
            Swal.fire({
              icon: "success",
              title: "Punto seteado",
              text: "Ultimo punto seteado correctamente.",
              timer: 2200,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "No fue posible setear el punto",
              text: "No se pudo setear el ultimo punto.",
              timer: 2400,
              showConfirmButton: false,
            });
          }
        }).catch(error => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Ocurrio un error al setear el ultimo punto.",
            timer: 2400,
            showConfirmButton: false,
          });
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrio un error al setear el ultimo punto.",
        timer: 2400,
        showConfirmButton: false,
      });
    }
  };

  const handleTodoRecorridoClick = () => {
    Swal.fire({
      title: 'Cargando posiciones...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    try {
      ListReports(contratoseleccionado, 1, 1); // Llamar a ListReports con 'all' y 'op' como 1 para mostrar todos los reportes

    } catch (error) {

      console.error("Error al manejar el recorrido completo:", error);
    }
  };

  const handl50RecorrClick = () => {
    Swal.fire({
      title: 'Cargando posiciones...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    try {
      ListReports(contratoseleccionado, 0, 0); // Llamar a ListReports con 'all' y 'op' como 1 para mostrar todos los reportes

    } catch (error) {

      console.error("Error al manejar el recorrido por 50 ultimos puntos:", error);
    }
  }

  const handleActualizarClick = () => {
    const contratoActual = contratoseleccionado || contratoVar;
    if (!contratoActual) return;

    setSelectedMarker(null);
    setSelectedMessage(null);
    setSelectedMarkerIndex(null);
    setActiveIconFilter(null);
    setLoadingSeguimiento(true);

    Swal.fire({
      title: 'Actualizando posiciones...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    ListReports(contratoActual, 0, 1);
  };

  const handleSetReporteAutomatico = () => {
    try {
      const mensajeSeleccionado =
        selectedMessage ||
        listaMensajes.find((item) => item.ID === selectedMarkerIndex) ||
        listaFiltrada.find((item) => item.ID === selectedMarkerIndex);
      const ubicacionSeleccionada =
        selectedMarker?.ubicacion ||
        mensajeSeleccionado?.Ciudad ||
        mensajeSeleccionado?.ubicacion ||
        mensajeSeleccionado?.NombreGeocerca ||
        mensajeSeleccionado?.PositionTime;
      const contratoId = contratoseleccionado?.ContractID;

      console.log("Estableciendo reporte automático para la ubicación:", ubicacionSeleccionada, "y contrato:", contratoId);

      if (!mensajeSeleccionado && !selectedMarkerIndex) {
        Swal.fire({
          icon: "warning",
          title: "Selecciona un punto",
          text: "Para generar el reporte automático debes seleccionar primero un punto de la lista de mensajes.",
          confirmButtonText: "Entendido"
        });
        return;
      }

      if (!ubicacionSeleccionada || !contratoId) {
        Swal.fire({
          icon: "warning",
          title: "No se pudo identificar la ubicación",
          text: "El punto seleccionado no tiene una ubicación válida para generar el reporte automático.",
          confirmButtonText: "Entendido"
        });
        return;
      }

      let data = {
        "ubicacion": ubicacionSeleccionada,
        "contrato": contratoId
      };

      // El punto seleccionado solo debe usarse una vez.
      setSelectedMarker(null);
      setSelectedMessage(null);
      setSelectedMarkerIndex(null);

      const json = JSON.stringify(data); // Convertir los datos a JSON para enviar al servidor

      // Llamada a la API para establecer un reporte automático
      axios.post(process.env.REACT_APP_SERVER + '/operaciones/setreporteautomatico', json, {
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('tkn')}` },
        withCredentials: true
      })
        .then(response => {
          if (response.data.success === true) {
            Swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Reporte automático creado",
              showConfirmButton: false,
              timer: 2500,
              timerProgressBar: true
            });
          } else {
            $(rootRef.current).find(`#${scopedId("danger-alert")}`).fadeTo(2000, 500).slideUp(500, function () {
              $(rootRef.current).find(`#${scopedId("danger-alert")}`).slideUp(2000);
            });
          }
        }).catch(error => {
          $(rootRef.current).find(`#${scopedId("danger-alert")}`).fadeTo(2000, 500).slideUp(500, function () {
            $(rootRef.current).find(`#${scopedId("danger-alert")}`).slideUp(2000);
          });
        });

    } catch (error) {
      $(rootRef.current).find(`#${scopedId("danger-alert")}`).fadeTo(2000, 500).slideUp(500, function () {
        $(rootRef.current).find(`#${scopedId("danger-alert")}`).slideUp(2000);
      });
    }
  };


  const handleVerSeguimientoClick = () => {
    if (isMultiventana) return;

    // Verifica si ya existe un intervalo configurado antes de establecer uno nuevo
    if (intervalRef.current) {
      clearInterval(intervalRef.current); // Limpia el intervalo existente
    }

    try {
      // Establece un nuevo intervalo para realizar la solicitud de seguimiento en tiempo real
      intervalRef.current = setInterval(() => {
        // console.log("Intervalo activo para el contrato = " + contratoVar.ContractID);
        ListReports(contratoVar, 0, 0); // Llama a la función para obtener los reportes
      }, 1000 * 5); // Cada 5 segundos
    } catch (error) {
      console.error("Error al manejar el seguimiento:", error); // Manejo de errores
    }
  };


  const formatFecha = (fecha) => {
    const isoString = new Date(fecha).toISOString();
    const year = isoString.slice(0, 4);
    const month = isoString.slice(5, 7);
    const day = isoString.slice(8, 10);
    const hours = isoString.slice(11, 13);
    const minutes = isoString.slice(14, 16);
    const seconds = isoString.slice(17, 19);
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const getDateDifferenceText = (startDate) => {
    const startDateObj = new Date(startDate);
    const endDateObj = new Date();
    if (isNaN(startDateObj) || isNaN(endDateObj)) {
      return 'Invalid date format';
    }
    const timeDifference = endDateObj.getTime() - startDateObj.getTime();
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const timeText = [];
    if (days > 0) timeText.push(`${days}d`);
    if (hours > 0) timeText.push(`${hours % 24}h`);
    if (minutes > 0) timeText.push(`${minutes % 60}m`);
    if (seconds > 0) timeText.push(`${seconds % 60}s`);
    return timeText.join(', ');
  };




  const getPolygonCenter = (polygon) => {
    const path = polygon.getPath();
    let latSum = 0;
    let lngSum = 0;
    const pathCount = path.getLength();

    // Sumar todas las latitudes y longitudes de los vértices
    path.forEach((latLng) => {
      latSum += latLng.lat();
      lngSum += latLng.lng();
    });

    // Calcular el centro
    return new google.maps.LatLng(latSum / pathCount, lngSum / pathCount);
  };

  const mostrarInformacionGeocerca = (geocerca, polygon) => {
    // Usar la función para obtener el centro del polígono
    const center = getPolygonCenter(polygon);

    // Filtrar los mensajes correspondientes a la geocerca seleccionada
    const mensajesDeGeocerca = listaMensajes.filter(
      (mensaje) => mensaje.NombreGeocerca === geocerca.geocerca
    );

    if (mensajesDeGeocerca.length === 0) {
      // Si no hay mensajes asociados a esta geocerca
      return;
    }

    // Encontrar la fecha más antigua y la más reciente
    const fechas = mensajesDeGeocerca.map((mensaje) => new Date(mensaje.PositionTime));
    const fechaInicial = new Date(Math.min(...fechas));
    const fechaFinal = new Date(Math.max(...fechas));
    const fechaFinalIndex = listaMensajes.findIndex(
      (mensaje) => new Date(mensaje.PositionTime).getTime() === fechaFinal.getTime()
    );
    // console.log("Fecha final index:", fechaFinalIndex);


    let mensajeDiferencia = null;
    let fechaAnterior = null;
    if (fechaFinalIndex > 0) {
      fechaAnterior = new Date(listaMensajes[fechaFinalIndex - 1].PositionTime);
      // console.log("Fecha anterior:", fechaAnterior);
    } else {
      // console.log("No hay fecha anterior disponible.");
      mensajeDiferencia = "🚛 En geocerca";
    }

    // Calcular la diferencia entre la fecha de inicio y la fecha final
    const diferencia = fechaAnterior - fechaInicial;

    // Convertir la diferencia de milisegundos a días, horas, minutos y segundos
    const dias = Math.floor(diferencia / (1000 * 60 * 60 * 24));
    const horas = Math.floor((diferencia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutos = Math.floor((diferencia % (1000 * 60 * 60)) / (1000 * 60));
    const segundos = Math.floor((diferencia % (1000 * 60)) / 1000);

    // Formatear la diferencia de tiempo
    const tiempoDiferencia = `${horas}h ${minutos}m ${segundos}s`;

    // Crear el contenido del InfoWindow con la fecha inicial, final y la diferencia
    const contentString = `
      <div>
        <h5>${geocerca.geocerca}</h4>
        <p><strong>Ingreso:</strong> ${formatFecha(fechaInicial)}</p>
        <p><strong>Salida:</strong> ${mensajeDiferencia ? mensajeDiferencia : formatFecha(fechaAnterior)}</p>
        ${mensajeDiferencia ? '' : `<p><strong>Duración en geocerca:</strong> ${tiempoDiferencia}</p>`}
      </div>
    `;

    // Crear y abrir el InfoWindow
    const infoWindow = new google.maps.InfoWindow({
      content: contentString,
      position: center,
    });

    infoWindow.open(mapRef.current);
  };

  const imagesModal = (e) => {
    e.preventDefault();
    images();
  }

  const monitoreoModal = (e) => {
    e.preventDefault();
    monitoreo();
  }

  const showModalAsignacion = (e) => {
    e.preventDefault();
    trayecto();
  }

  const consolidadoModal = (e) => {
    e.preventDefault();
    consolidado();
  }

  const editarContratoModal = (e) => {
    e.preventDefault();
    showEditContract?.(contratoVar);
  }

  const streamingModal = (e) => {
    e.preventDefault();
    (streaming || videos)?.();
  }

  const valitronicsModal = (e) => {
    e.preventDefault();
    valitronics();
  }

  const checkListModal = (e) => {
    e.preventDefault();
    checkList();
  }

  const handleBackgroundListaMensajes = (mensaje) => {
    if (!mensaje) return "";

    const sinGps =
      Number(mensaje.latitude) === 0 || Number(mensaje.SatelliteCount) === 0;
    const sinSenal = Number(mensaje.csq) === 99;

    if (sinGps && sinSenal) {
      return "background-class2";
    }

    if (!sinGps && sinSenal) {
      return "background-class3";
    }

    if (sinGps && !sinSenal) {
      return "background-class";
    }

    return "";
  };

  //Funcion para dibujar geocercas en el mapa
  const dibujarGeocercas = () => {
    // Limpiar los polígonos previamente dibujados si es necesario
    geocercaPolygons.forEach(polygon => polygon.setMap(null));

    // Limpiar el array de polígonos
    setGeocercaPolygons([]);

    // Dibujar nuevos polígonos
    const newPolygons = uniquesGeocerca.map((geocerca) => {
      const vertices = geocerca.vertices.split('/');
      const coords = vertices.map((coord) => {
        const [lat, lng] = coord.replace(/[()]/g, '').split(',').map(Number);
        return { lat, lng };
      });

      const polygon = new google.maps.Polygon({
        paths: coords,
        strokeColor: "#800080",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#9c27b0",
        fillOpacity: 0.35,
      });


      polygon.setMap(mapRef.current);

      // Añadir un evento de clic al polígono
      google.maps.event.addListener(polygon, 'click', () => {
        console.log("Geocerca clickeada:", geocerca);
        console.log("Vertices:", coords);
        console.log("Polygon:", polygon);
        // Mostrar información de la geocerca en un InfoWindow
        mostrarInformacionGeocerca(geocerca, polygon);
      });


      return polygon;
    });

    // Actualizar el estado de los polígonos
    setGeocercaPolygons(newPolygons);
  };


  useEffect(() => {
    if (switchValueGeo) {
      // Solo dibujar geocercas si el switch está activado
      dibujarGeocercas();
    } else {
      // Si el switch se desactiva, eliminamos los polígonos del mapa
      geocercaPolygons.forEach(polygon => polygon.setMap(null));
    }
  }, [switchValueGeo, uniquesGeocerca]);

  //(3.804092023012944,-76.6342724388831)/(3.801265846222622,-76.63058171927861)
  useEffect(() => {
    // console.log("Lista de mensajes actualizada:", listaMensajes);

    // Filtramos los valores null y extraemos las geocercas únicas
    const uniques = [...new Set(listaMensajes.map((objeto) => objeto.NombreGeocerca).filter(item => item !== null))];

    // Creamos un array de objetos con la asociación geocerca -> vertices
    const geocercaWithVertices = uniques.map((geocerca) => {
      // Buscar los vertices para la geocerca actual
      const objeto = listaMensajes.find((item) => item.NombreGeocerca === geocerca && item.Vertices);
      return objeto ? { geocerca, vertices: objeto.Vertices } : null;
    }).filter(item => item !== null); // Eliminamos los objetos nulos si no se encuentra Vertices para una geocerca

    // Actualizamos el estado con el array de objetos
    // console.log("Geocercas con Vertices:", geocercaWithVertices);
    setUniquesGeocerca(geocercaWithVertices);

    setLastReport(listaMensajes[0]);

  }, [listaMensajes]);

  useEffect(() => {
    if (rutaseleccionadaprop !== null) {
      GetPolyline();
    }
  }, [rutaseleccionadaprop]);


  useEffect(() => {
    if (listaFiltrada.length) rutaenMapa(listaFiltrada, /* op: igual que antes */  1);
  }, [listaFiltrada]);

  if (!isOpen) return null;

  return (
    <div ref={rootRef} style={{ position: "relative" }}>
      <div
        id={scopedId("modal-seguimiento-whatsapp-captura")}
        className="seguimiento-modal"
        style={{ backgroundColor: "#fff", padding: "4px" }}
      >
        <MDBRow style={{ marginTop: '-15px', marginBottom: '10px', alignItems: 'center' }} className="seguimiento-links-row">
          <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', flexDirection: 'row' }} className="seguimiento-links">
              <a className="seguimiento-action-link" href="#" onClick={(e) => { imagesModal(e) }}><i className="bx bx-image" aria-hidden="true" />Imagenes IA</a>
              <a className="seguimiento-action-link" href="#" onClick={(e) => { streamingModal(e) }}><i className="bx bx-radio-circle-marked" aria-hidden="true" />Streaming</a>
              <a className="seguimiento-action-link" href="#" onClick={(e) => { valitronicsModal(e) }}><i className="bx bx-cube" aria-hidden="true" />Valitronics</a>
              <a className="seguimiento-action-link" href="#" onClick={(e) => { checkListModal(e) }}><i className="bx bx-check-square" aria-hidden="true" />Check List</a>
              <a className="seguimiento-action-link" href="#" onClick={(e) => { consolidadoModal(e) }}><i className="bx bx-file" aria-hidden="true" />Consolidado</a>
              <a className="seguimiento-action-link" href="#" onClick={(e) => { editarContratoModal(e) }}><i className="bx bx-edit-alt" aria-hidden="true" />Editar Contrato</a>
            </div>
          </div>
        </MDBRow>
        <MDBRow style={{ marginBottom: '10px' }}>
          <MDBCol md='5'>
            <nav class="navbar navbar-expand-lg custom-navbar seguimiento-topbar">
              <div class="container-fluid">
                <a class="navbar-brand" href="#" style={{ color: '#fff' }}>MENU</a>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target={`#${scopedId("navbarNavDropdown")}`} aria-controls={scopedId("navbarNavDropdown")} aria-expanded="false" aria-label="Toggle navigation">
                  <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id={scopedId("navbarNavDropdown")} style={{ display: 'flex' }}>
                  <ul class="navbar-nav">
                    <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" id={scopedId("navbarDropdownConfiguracion")} role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff' }}>
                        Configuración
                      </a>
                      <ul class="dropdown-menu" aria-labelledby={scopedId("navbarDropdownConfiguracion")}>
                        <li onClick={showModalAsignacion} style={{ cursor: "pointer" }}><a class="dropdown-item">Asignar Trayecto</a></li>
                        <li onClick={handleVerUltPuntoClick} style={{ cursor: "pointer" }}><a class="dropdown-item">Ver ultimo punto</a></li>
                        <li onClick={handleSetUltPunto} style={{ cursor: "pointer" }}><a class="dropdown-item">Setear punto</a></li>
                      </ul>
                    </li>
                    <li class="nav-item dropdown">
                      <a class="nav-link dropdown-toggle" href="#" id={scopedId("navbarDropdownReportes")} role="button" data-bs-toggle="dropdown" aria-expanded="false" style={{ color: '#fff' }}>
                        Reportes
                      </a>
                      <ul class="dropdown-menu" aria-labelledby={scopedId("navbarDropdownReportes")} style={{ width: "230px" }}>
                        <li onClick={handl50RecorrClick}><a class="dropdown-item" style={{ cursor: "pointer" }}>Visualizar ultimos (50)</a></li>
                        {/* <li  ><a class="dropdown-item">Visualizar ultimos (100)</a></li>
                      <li  ><a class="dropdown-item">Visualizar ultimos (200)</a></li>
                      <li  ><a class="dropdown-item">Visualizar ultimos (500)</a></li> */}
                        <li onClick={handleTodoRecorridoClick} ><a class="dropdown-item" style={{ cursor: "pointer" }}>Visualizar todos los reportes</a></li>
                      </ul>
                    </li>
                  </ul>

                </div>
              </div>
            </nav>
          </MDBCol>

          <MDBCol md='7'>
            <MDBRow className="seguimiento-kpis">
              <MDBCol md='4'>
                <div className="seguimiento-kpi-card"><FaRoute size={18} className='icono rounded' /> % Completado<br /><span id={scopedId("contenedordistancia")} /></div>
              </MDBCol>
              <MDBCol md='4'>
                <div className="seguimiento-kpi-card"><FaClock size={18} className='icono' /> Ult Reporte<br /><span id={scopedId("contenedortiempo")} /></div>
              </MDBCol>
              <MDBCol md='4'>
                <div id={scopedId("contenedorestadodiv")} className="seguimiento-kpi-card"><FaLock size={18} className='icono' /> Ult Estado<br /><div id={scopedId("contenedorestado")}></div></div>
              </MDBCol>
            </MDBRow>
          </MDBCol>

        </MDBRow>
        <MDBRow className="seguimiento-content-row">
          <MDBCol md='5'>
            <div className="seguimiento-map-shell" style={{ position: "relative" }}>
              <div ref={mapContainerRef} className="seguimiento-map" />
              {loadingSeguimiento && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    background: "rgba(255, 255, 255, 0.72)",
                    backdropFilter: "blur(1px)",
                    zIndex: 5,
                    borderRadius: "18px",
                  }}
                >
                  <Spinner color="primary" />
                  <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f3b57" }}>
                    Cargando mensajes y marcadores...
                  </div>
                </div>
              )}
            </div>

          </MDBCol>
          <MDBCol md='7' className="seguimiento-panel seguimiento-content-panel">
            <MDBRow className="seguimiento-switches">
              <MDBCol md='12'>
                <div style={{ overflow: 'hidden', width: '100%' }}>
                  <motion.div
                    id={scopedId("informacioneventos")}
                    className="scrolling-text"
                    initial={{ x: '100%' }}
                    animate={{ x: '-100%' }}
                    transition={{
                      duration: 10,
                      repeat: Infinity,
                      ease: 'linear',
                    }}
                  >
                  </motion.div>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow>

              <MDBCol md='5'>
                <div className="form-check form-switch custom-switch">
                  <input className="form-check-input" type="checkbox" role="switch" id={scopedId("mySwitch")} checked={isMultiventana ? false : switchValue} onChange={handleSwitchChange} disabled={isMultiventana} />
                  <label className="form-check-label" htmlFor={scopedId("mySwitch")}>Seguimiento tiempo real</label>
                </div>
              </MDBCol>
              <MDBCol md='4'>
                <div className="form-check form-switch custom-switch">
                  <input className="form-check-input" type="checkbox" role="switch" id={scopedId("autocentrado")} />
                  <label className="form-check-label" htmlFor={scopedId("autocentrado")}>Autocentrado</label>
                </div>
              </MDBCol>
              <MDBCol md='3'>
                <div className="form-check form-switch custom-switch">
                  <input className="form-check-input" type="checkbox" role="switch" id={scopedId("Geocerca")} checked={switchValueGeo} onChange={handleSwitchChangeGeo} />
                  <label className="form-check-label" htmlFor={scopedId("Geocerca")}>Geocercas</label>
                </div>
              </MDBCol>
            </MDBRow>

            <div
              className="container containerReporteSeguimiento seguimiento-meta-card"
              id={scopedId("contenedor")}
              style={{ fontSize: '10px', position: 'relative' }}
            >
              <button
                type="button"
                className="seguimiento-info-button seguimiento-meta-info-button"
                onClick={() => setModalInformacionExtra(true)}
                aria-label="Ver informacion adicional"
                title="Ver informacion adicional"
              >
                <FaInfoCircle size={18} />
              </button>

              <div className="row py-1">
                <div className="col">
                  <b style={{ fontSize: '12px' }}>DISPOSITIVO:</b>
                  <div style={{ fontSize: '12px' }} id={scopedId("dispositivo_seg")}>
                  </div>
                </div>

                <div className="col">
                  <b style={{ fontSize: '12px' }}>CONTRATO:</b>
                  <div style={{ fontSize: '12px' }} id={scopedId("contrato_seg")}>
                  </div>
                </div>
              </div>
              <div className="row py-1">
                <div className="col">
                  <b style={{ fontSize: '12px' }}>CLIENTE:</b>
                  <div style={{ fontSize: '12px' }} id={scopedId("cliente_seg")}></div>
                </div>
                <div className="col">
                  <div>
                    <b style={{ fontSize: '12px' }}>RUTA:</b>
                    <div style={{ fontSize: '12px' }} id={scopedId("ruta_seg")}></div>
                  </div>
                </div>
              </div>
              <div className="row py-2">
                <div className="col-12">
                  <div
                    className="seguimiento-actions"
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      gap: "12px",
                      flexWrap: "wrap",
                    }}
                  >
                    <EnviarReporteContratoButton
                      contractId={contratoVar?.ContractID}
                      className="btn btn-primary seguimiento-action-button"
                      style={{
                        minHeight: "38px",
                        padding: "0 14px",
                        fontWeight: 700,
                        fontSize: "13px",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                        boxShadow: "0 8px 18px rgba(17, 52, 77, 0.10)",
                      }}
                    />

                    <button
                      type="button"
                      className="btn btn-primary seguimiento-action-button"
                      onClick={handleSetReporteAutomatico}
                      aria-label="Generar reporte automatico"
                      title="Generar reporte automatico"
                      style={{
                        minHeight: "38px",
                        padding: "0 14px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        fontWeight: 700,
                        fontSize: "13px",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                        boxShadow: "0 8px 18px rgba(17, 52, 77, 0.10)",
                      }}
                    >
                      <FaRoute size={15} aria-hidden="true" style={{ flexShrink: 0 }} />
                      R automático
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary seguimiento-action-button"
                      onClick={handleVerUltPuntoClick}
                      style={{
                        minHeight: "38px",
                        padding: "0 14px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        fontWeight: 700,
                        fontSize: "13px",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                        boxShadow: "0 8px 18px rgba(17, 52, 77, 0.10)",
                      }}
                      aria-label="Abrir último punto"
                      title="Abrir último punto"
                    >
                      <i className="bx bx-map-pin" aria-hidden="true" />
                      Ult punto
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary seguimiento-action-button"
                      onClick={handleExportarExcel}
                      disabled={loadingSeguimiento || exportandoExcel}
                      aria-label="Exportar reporte a Excel"
                      title="Exportar reporte a Excel"
                      style={{
                        minHeight: "38px",
                        padding: "0 14px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        fontWeight: 700,
                        fontSize: "13px",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                        boxShadow: "0 8px 18px rgba(17, 52, 77, 0.10)",
                      }}
                    >
                      {exportandoExcel ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ width: "0.95rem", height: "0.95rem", borderWidth: "0.16em" }}
                        ></span>
                      ) : (
                        <FaFileExcel
                          size={15}
                          aria-hidden="true"
                          style={{ flexShrink: 0 }}
                        />
                      )}
                      {exportandoExcel ? "Exportando..." : "Exportar"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary seguimiento-action-button"
                      onClick={handleCompartirWhatsApp}
                      disabled={isShareButtonBusy}
                      data-capture-share-button="true"
                      data-capture-label="Compartir WhatsApp"
                      aria-label="Compartir por WhatsApp"
                      title="Compartir por WhatsApp"
                      style={{
                        pointerEvents: isShareButtonBusy ? "none" : "auto",
                        opacity: isShareButtonBusy ? 0.92 : 1,
                        minHeight: "38px",
                        padding: "0 14px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        fontWeight: 700,
                        fontSize: "13px",
                        borderRadius: "999px",
                        whiteSpace: "nowrap",
                        boxShadow: isShareButtonBusy
                          ? "0 0 0 3px rgba(37, 211, 102, 0.14), 0 8px 18px rgba(37, 211, 102, 0.16)"
                          : "0 8px 18px rgba(17, 52, 77, 0.10)",
                        transform: isShareButtonBusy ? "translateY(-1px)" : "translateY(0)",
                        transition: "all 180ms ease",
                        background: preparandoWhatsapp
                          ? "linear-gradient(135deg, #1f7fd1 0%, #0b5c8f 100%)"
                          : undefined,
                        borderColor: preparandoWhatsapp
                          ? "#0b5c8f"
                          : undefined,
                      }}
                    >
                      {preparandoWhatsapp && (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                          style={{ width: "0.95rem", height: "0.95rem", borderWidth: "0.16em" }}
                        ></span>
                      )}
                      {!preparandoWhatsapp && (
                        <FaWhatsapp
                          size={15}
                          aria-hidden="true"
                          style={{ flexShrink: 0 }}
                        />
                      )}
                      {preparandoWhatsapp
                        ? "Preparando..."
                        : "WhatsApp"}
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary seguimiento-action-button seguimiento-refresh-icon-button"
                      onClick={handleActualizarClick}
                      disabled={loadingSeguimiento}
                      aria-label="Actualizar las 50 posiciones iniciales"
                      title="Actualizar las 50 posiciones iniciales"
                    >
                      <i className="bx bx-refresh" aria-hidden="true" />
                    </button>

                    <button
                      type="button"
                      className="seguimiento-info-button seguimiento-actions-info-button"
                      onClick={() => setModalInformacionExtra(true)}
                      style={{
                        display: "none",
                        border: "none",
                        background: "#eef6ff",
                        color: "#007bff",
                        width: "38px",
                        height: "38px",
                        borderRadius: "999px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 6px 14px rgba(0, 123, 255, 0.12)",
                        cursor: "pointer",
                      }}
                      aria-label="Ver información adicional"
                      title="Ver información adicional"
                    >
                      <FaInfoCircle size={18} />
                    </button>
                  </div>
                </div>
              </div>

              <div
                className={`containerReporte containerReporteContratoSeguimiento seguimiento-table-card ${activeTab === "monitoreo" ? "tracking-monitoring-host" : ""}`}
                style={{
                  height: "390px",
                  overflow: "hidden",
                  width: "100%",
                  maxWidth: "100%",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Pestañas */}
                {loadingSeguimiento && (
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      background: "rgba(255, 255, 255, 0.82)",
                      zIndex: 4,
                    }}
                  >
                    <Spinner color="primary" />
                    <div style={{ fontSize: "14px", fontWeight: 600, color: "#1f3b57" }}>
                      Cargando lista de mensajes...
                    </div>
                  </div>
                )}
                <div className="tabs">
                  <button
                    type="button"
                    className={`tab ${activeTab === "tabla" ? "active" : ""}`}
                    onClick={() => setActiveTab("tabla")}
                  >
                    Lista mensajes
                  </button>
                  {bitOpenMonitoreo && (
                    <button
                      type="button"
                      className={`tab ${activeTab === "monitoreo" ? "active" : ""}`}
                      onClick={() => setActiveTab("monitoreo")}
                    >
                      Monitoreo
                    </button>
                  )}
                  {/* <button className="tab" onClick={() => setShowIconModal(true)}>
                  Filtrar Iconos
                </button> */}
                </div>

                {/* Contenido de las pestañas */}
                <div
                  className="content"
                  style={{ flex: "1 1 auto", minHeight: 0, overflow: "hidden" }}
                >
                  {activeTab === "tabla" || !bitOpenMonitoreo ? (
                    <div className="message-table-scroll contrato-mensajes-scroll tracking-list-messages-scroll">
                      <table
                        id="tabla-mensajes-trafico-seguimiento"
                        className="tableReporteContratoSeguimiento contrato-mensajes-table"
                        style={{ width: "100%", minWidth: "586px", tableLayout: "fixed" }}
                      >
                        <colgroup>
                          <col style={{ width: "50px" }} />
                          <col style={{ width: "50px" }} />
                          <col style={{ width: "80px" }} />
                          <col style={{ width: "90px" }} />
                          <col style={{ width: "80px" }} />
                          <col style={{ width: "28px" }} />
                          <col style={{ width: "28px" }} />
                          <col style={{ width: "40px" }} />
                          <col style={{ width: "32px" }} />
                          <col span="6" style={{ width: "18px" }} />
                        </colgroup>
                        <thead>
                          <tr>
                            <th className="sticky-header" style={{ width: "50px", textAlign: "center" }}>Fecha</th>
                            <th className="sticky-header" style={{ width: "50px", textAlign: "center" }}>Guardado</th>
                            <th className="sticky-header" style={{ width: "80px", textAlign: "center" }}>Lugar</th>
                            <th className="sticky-header" style={{ width: "90px", textAlign: "center" }}>Evento</th>
                            <th className="sticky-header" style={{ width: "80px", textAlign: "center" }}>Geocerca</th>
                            <th className="sticky-header" style={{ width: "28px", textAlign: "center" }}>Bat</th>
                            <th className="sticky-header" style={{ width: "28px", textAlign: "center" }}>Gps</th>
                            <th className="sticky-header" style={{ width: "40px", textAlign: "center" }}>Vel</th>
                            <th className="sticky-header" style={{ width: "32px", textAlign: "center" }}>Csq</th>
                            <th
                              className="sticky-header icon-group-header"
                              colSpan={6}
                              style={{ width: "108px", textAlign: "center", padding: "4px" }}
                            >
                              <details className="icon-filter-dropdown">
                                <summary title="Filtrar por icono">
                                  <span className="icon-filter-summary-content">
                                    {activeIconFilter ? (
                                      <img src={activeIconFilter} alt={getIconOptionLabel(activeIconFilter)} width={18} height={18} />
                                    ) : (
                                      <span className="icon-filter-placeholder" />
                                    )}
                                    <span className="icon-filter-summary-label">
                                      {activeIconFilter ? getIconOptionLabel(activeIconFilter) : "Todos los iconos"}
                                    </span>
                                  </span>
                                  <span className="icon-filter-chevron">▼</span>
                                </summary>
                                <div className="icon-filter-menu">
                                  <button
                                    type="button"
                                    className={`icon-filter-option ${!activeIconFilter ? "active" : ""}`}
                                    onClick={(event) => {
                                      clearIconFilter();
                                      event.currentTarget.closest("details")?.removeAttribute("open");
                                    }}
                                  >
                                    <span className="icon-filter-placeholder" />
                                    <span>Todos los iconos</span>
                                  </button>
                                  {uniqueIconPaths.map((path) => (
                                    <button
                                      type="button"
                                      key={path}
                                      className={`icon-filter-option ${path === activeIconFilter ? "active" : ""}`}
                                      onClick={(event) => {
                                        filterMarkersByIcon(path);
                                        event.currentTarget.closest("details")?.removeAttribute("open");
                                      }}
                                    >
                                      <img src={path} alt={getIconOptionLabel(path)} width={18} height={18} />
                                      <span>{getIconOptionLabel(path)}</span>
                                    </button>
                                  ))}
                                </div>
                              </details>
                              {/* Si quieres un título encima */}

                              {/* Aquí van los botones‐icono filtrables */}
                              <div style={{ display: "none", justifyContent: "center", gap: "4px" }}>
                                {uniqueIconPaths.map(path => (
                                  <img
                                    key={path}
                                    src={path}
                                    width={18}
                                    height={18}
                                    style={{
                                      cursor: "pointer",
                                      opacity: path === activeIconFilter ? 1 : 0.4,
                                      border: path === activeIconFilter ? "2px solid #007bff" : "2px solid transparent",
                                      borderRadius: 2,
                                    }}
                                    onClick={() => filterMarkersByIcon(path)}
                                  />
                                ))}

                                {/* Botón para quitar el filtro */}
                                <i
                                  className="bx bx-x-circle"
                                  style={{
                                    fontSize: 20,
                                    cursor: "pointer",
                                    marginLeft: 12,
                                    opacity: activeIconFilter ? 1 : 0.3,
                                    color: "#d00"
                                  }}
                                  onClick={clearIconFilter}
                                  title="Limpiar filtro"
                                />
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {listaFiltrada.map((objeto, index) => (
                            <tr
                              key={objeto.ID}
                              className={handleBackgroundListaMensajes(objeto)}
                              onClick={() => handleTableRowClick(index)}
                            >
                              <td style={{ padding: "5px" }}>{formatFecha(objeto.PositionTime)}</td>
                              <td style={{ padding: "5px" }}>{objeto.DateTimeActualizacion ? formatFecha(objeto.DateTimeActualizacion) : ""}</td>
                              <td>{objeto.latitude === 0 ? <b>SIN GPS</b> : objeto.Ciudad}</td>
                              <td style={{ padding: "5px" }}>{objeto.Evento ?? ""}</td>
                              <td style={{ paddingLeft: "5px" }}>{objeto.NombreGeocerca}</td>
                              <td style={{ textAlign: "center" }}>
                                {parseFloat(objeto.Battery).toFixed(2).replace(/\.?0+$/, "")}
                              </td>
                              <td style={{ textAlign: "center" }}>{objeto.SatelliteCount}</td>
                              <td style={{ padding: "5px" }}>{objeto.Speed}</td>
                              <td style={{ textAlign: "center" }}>{objeto.csq ?? ""}</td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconSatelite.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono satélite"
                                />
                              </td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconMoving.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono movimiento"
                                />
                              </td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconLocked.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono bloqueo"
                                />
                              </td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconDesvio.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono desvío"
                                />
                              </td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconBack.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono retorno"
                                />
                              </td>
                              <td className="icon-cell">
                                <img
                                  src={objeto.IconAlejado.substring(1)}
                                  width="18"
                                  height="18"
                                  alt="Icono alejado"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div
                      className="containerReporte containerReporteContratoSeguimiento"
                      style={{ maxHeight: "85vh", overflowY: "auto", maxWidth: "100%", width: "100%" }}
                    >
                      <FormReporteServcioModalTracking
                        contrato={contratoVar.ContractID}
                        lastReport={lastReport}
                        bitInsert={bitInsertMonitoreo}
                        bitEdit={bitEditMonitoreo}
                      />
                    </div>
                  )}
                </div>

                {/* Estilos */}
                <style jsx>{`
                .containerReporte {
                  display: flex;
                  flex-direction: column;
                  margin: 0;
                  width: 100%;
                  max-width: 100%;
                  border-radius: 5px;
                  box-sizing: border-box;
                }

                .tabs {
                  display: flex;
                  gap: 5px;
                  border-bottom: 2px solid #ddd;
                  padding-bottom: 5px;
                }

                .tab {
                  background: #f0f0f0;
                  padding: 8px 16px;
                  border: none;
                  cursor: pointer;
                  border-radius: 5px 5px 0 0;
                  transition: all 0.3s;
                }

                .tab.active {
                  background: linear-gradient(135deg, #0b5c8f 0%, #1b84c5 100%);
                  color: white;
                  font-weight: bold;
                }

                .content {
                  display: flex;
                  flex-direction: column;
                  flex: 1 1 auto;
                  min-height: 0;
                  width: 100%;
                  box-sizing: border-box;
                }

                .seguimiento-content-row {
                  align-items: stretch;
                }

                .seguimiento-content-row > [class*="col-"] {
                  display: flex;
                  min-height: 0;
                }

                .seguimiento-map-shell {
                  display: flex;
                  flex: 1 1 auto;
                  min-height: 0;
                  width: 100%;
                }

                .seguimiento-content-row .seguimiento-map {
                  width: 100%;
                  height: 100%;
                  min-height: 0 !important;
                }

                .seguimiento-content-panel {
                  display: flex;
                  flex-direction: column;
                }

                .message-table-scroll {
                  position: relative;
                  flex: 1 1 auto;
                  min-height: 0;
                  overflow-y: auto;
                  overflow-x: auto;
                  scrollbar-gutter: stable;
                }

                .contrato-mensajes-scroll {
                  position: relative;
                  height: 0;
                  flex: 1 1 0;
                  overflow-y: auto !important;
                  overflow-x: auto !important;
                  isolation: isolate;
                }

                .contrato-mensajes-table {
                  width: 100% !important;
                  min-width: 586px !important;
                  table-layout: fixed !important;
                  border-collapse: collapse;
                  overflow: visible !important;
                }

                .contrato-mensajes-table thead th {
                  position: sticky !important;
                  top: 0 !important;
                  z-index: 20 !important;
                  background: #0b5c8f !important;
                  color: #fff !important;
                }

                #tabla-mensajes-trafico-seguimiento {
                  width: 100%;
                  min-width: 586px;
                  table-layout: fixed;
                  border-collapse: collapse;
                  border-spacing: 0;
                }

                #tabla-mensajes-trafico-seguimiento th,
                #tabla-mensajes-trafico-seguimiento td {
                  font-size: 11px;
                  word-break: break-word;
                  overflow-wrap: anywhere;
                  text-align: center;
                  vertical-align: middle;
                  padding: 5px 4px;
                }

                #tabla-mensajes-trafico-seguimiento thead th {
                  position: sticky !important;
                  top: 0 !important;
                  z-index: 10 !important;
                  background: #0b5c8f !important;
                  background-clip: padding-box;
                  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.18);
                }

                #tabla-mensajes-trafico-seguimiento thead {
                  position: sticky;
                  top: 0;
                  z-index: 9;
                }

                #tabla-mensajes-trafico-seguimiento .icon-group-header {
                  min-width: 108px;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-dropdown {
                  position: relative;
                  width: 100%;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-dropdown summary {
                  list-style: none;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  gap: 6px;
                  width: 100%;
                  min-height: 30px;
                  padding: 5px 8px;
                  border-radius: 8px;
                  border: 1px solid rgba(255, 255, 255, 0.45);
                  background: rgba(255, 255, 255, 0.14);
                  cursor: pointer;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-dropdown summary::-webkit-details-marker {
                  display: none;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-summary-content {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  min-width: 0;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-summary-label {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  color: #fff;
                  font-size: 11px;
                  font-weight: 600;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-placeholder {
                  display: inline-block;
                  width: 18px;
                  height: 18px;
                  min-width: 18px;
                  border-radius: 50%;
                  background: rgba(255, 255, 255, 0.4);
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-chevron {
                  color: #fff;
                  font-size: 10px;
                  line-height: 1;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-menu {
                  position: absolute;
                  top: calc(100% + 4px);
                  left: 0;
                  right: 0;
                  z-index: 20;
                  display: flex;
                  flex-direction: column;
                  gap: 2px;
                  max-height: 220px;
                  overflow-y: auto;
                  padding: 6px;
                  border-radius: 10px;
                  background: #fff;
                  box-shadow: 0 12px 24px rgba(16, 43, 67, 0.2);
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-dropdown:not([open]) > .icon-filter-menu {
                  display: none;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-option {
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  width: 100%;
                  padding: 6px 8px;
                  border: none;
                  border-radius: 8px;
                  background: transparent;
                  color: #16324a;
                  font-size: 11px;
                  text-align: left;
                  cursor: pointer;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-option.active {
                  background: rgba(27, 132, 197, 0.12);
                  font-weight: 700;
                }

                #tabla-mensajes-trafico-seguimiento .icon-filter-option:hover {
                  background: rgba(27, 132, 197, 0.08);
                }

                #tabla-mensajes-trafico-seguimiento .icon-cell {
                  width: 18px;
                  min-width: 18px;
                  max-width: 18px;
                  padding: 4px 2px !important;
                  text-align: center;
                  overflow: hidden;
                }

                #tabla-mensajes-trafico-seguimiento .icon-cell img {
                  display: inline-block;
                  vertical-align: middle;
                }

                @media (max-width: 768px) {
                  .containerReporte {
                    padding: 0 10px;
                  }
                  .tab {
                    padding: 6px 12px;
                  }

                  .seguimiento-actions {
                    width: 100%;
                    justify-content: center !important;
                    align-items: center !important;
                    box-sizing: border-box;
                  }

                  .seguimiento-action-button {
                    width: 100%;
                    max-width: 100%;
                    box-sizing: border-box;
                  }

                  .seguimiento-info-button {
                    box-sizing: border-box;
                  }
                }

                .seguimiento-hover-actions {
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                  min-width: 0;
                  position: relative;
                  z-index: 30;
                }

                .seguimiento-actions-trigger {
                  display: inline-flex;
                  align-items: center;
                  gap: 6px;
                  min-height: 38px;
                  width: auto;
                  max-width: 130px;
                  padding: 0 13px;
                  border: 0;
                  border-radius: 999px;
                  background: linear-gradient(145deg, #167fba 0%, #07527f 100%);
                  color: #fff;
                  font-size: 13px;
                  font-weight: 700;
                  box-shadow: 0 7px 16px rgba(17, 52, 77, 0.18);
                  cursor: pointer;
                  white-space: nowrap;
                  overflow: hidden;
                  transition: opacity 180ms ease, box-shadow 180ms ease, transform 180ms ease;
                }

                .seguimiento-actions-trigger:hover,
                .seguimiento-hover-actions:hover .seguimiento-actions-trigger {
                  transform: translateY(-1px);
                  box-shadow: 0 0 0 3px rgba(22, 127, 186, 0.14), 0 9px 20px rgba(17, 52, 77, 0.22);
                  outline: none;
                }

                .seguimiento-actions-trigger i {
                  font-size: 18px;
                  line-height: 1;
                }

                .seguimiento-hover-actions:hover .seguimiento-actions-trigger {
                  opacity: 0;
                  visibility: hidden;
                  pointer-events: none;
                  transform: translateX(-8px);
                }

                .seguimiento-hover-actions-list {
                  display: inline-flex;
                  align-items: center;
                  gap: 8px;
                  width: 0;
                  max-width: 0;
                  overflow: hidden;
                  opacity: 0;
                  transform: translateX(-12px);
                  pointer-events: none;
                  transition: width 260ms ease, max-width 260ms ease, opacity 180ms ease, transform 260ms ease;
                }

                .seguimiento-hover-actions:hover .seguimiento-hover-actions-list {
                  width: auto;
                  max-width: 760px;
                  opacity: 1;
                  transform: translateX(0);
                  pointer-events: auto;
                }

                .seguimiento-hover-action {
                  flex: 0 0 auto;
                  min-height: 38px !important;
                  padding: 0 13px !important;
                  border-radius: 999px !important;
                  white-space: nowrap;
                  box-shadow: 0 7px 16px rgba(17, 52, 77, 0.14) !important;
                  transition: transform 180ms ease, box-shadow 180ms ease;
                }

                .seguimiento-hover-action:hover,
                .seguimiento-hover-action:focus-visible {
                  transform: translateY(-2px);
                  box-shadow: 0 9px 20px rgba(17, 52, 77, 0.22) !important;
                  outline: none;
                }

                .seguimiento-hover-excel {
                  background: #126da2 !important;
                }

                .seguimiento-hover-refresh {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 7px;
                }

                .seguimiento-hover-refresh i {
                  font-size: 17px;
                }

                @media (max-width: 768px) {
                  .seguimiento-hover-actions {
                    width: 100%;
                    justify-content: center;
                    flex-wrap: wrap;
                  }

                  .seguimiento-hover-actions-list {
                    width: 100%;
                    max-width: 0;
                    justify-content: center;
                  }

                  .seguimiento-hover-actions:hover .seguimiento-hover-actions-list {
                    max-width: 100%;
                  }

                  .seguimiento-hover-action {
                    padding: 0 10px !important;
                    font-size: 12px !important;
                  }
                }

                .seguimiento-refresh-icon-button {
                  display: inline-flex !important;
                  align-items: center;
                  justify-content: center;
                  width: 38px !important;
                  min-width: 38px !important;
                  height: 38px;
                  padding: 0 !important;
                  border-radius: 999px !important;
                  background: #8bc34a !important;
                  border-color: #8bc34a !important;
                  color: #fff !important;
                  box-shadow: 0 7px 16px rgba(139, 195, 74, 0.28) !important;
                }

                .seguimiento-refresh-icon-button:hover,
                .seguimiento-refresh-icon-button:focus-visible {
                  background: #76ad36 !important;
                  border-color: #76ad36 !important;
                  color: #fff !important;
                  box-shadow: 0 0 0 3px rgba(139, 195, 74, 0.18), 0 9px 20px rgba(139, 195, 74, 0.34) !important;
                  outline: none;
                }

                .seguimiento-refresh-icon-button i {
                  font-size: 18px;
                  line-height: 1;
                }
              `}</style>
              </div>


            </div>

          </MDBCol>

        </MDBRow>
        <BaseModalAuto2
          isOpen={modalInformacionExtra}
          onClose={() => setModalInformacionExtra(false)}
          size={80}
          // onMouseEnter / onMouseLeave para que no se cierre si pasamos el mouse al modal
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
          title=""
        >
          <ModalInfromacionExtra contrato={contratoVar} />
        </BaseModalAuto2>





        {/* <div className="alert alert-success" id="success-alert">
        <strong>Exitoso! </strong> Los cambios han sido realizados con exito.
      </div>

      <div className="alert alert-danger" id="danger-alert">
        <strong>Error! </strong> Se ha presentado un error, valide la información.
      </div> */}
      </div>
    </div>
  );
};

export default Modal;

